<template>
  <div class="container">
    <Editor api-key="qmmn21opcrrblgzue2p7mj51cdpyxgj8xq6sc3amhko97ehp" :init="editorInit" :value="value | richText"
      @input="$emit('input', $event)" />
    <!-- <i class="count">{{ wordCount }}/{{ innerTextMaxLength }}</i> -->
  </div>
</template>

<script>
  import Editor from '@tinymce/tinymce-vue'
  import {
    upload
  } from '@/api/upload';
  export default {
    name: '',
    components: {
      Editor
    },
    props: {
      innerTextMaxLength: {
        type: Number,
        default: 50000
      },
      value: {
        type: String,
        default: ''
      },
      height: {
        type: Number,
        default: 500
      },
      width: {
        type: String,
        default: '100%'
      },
      scene_name: {
        type: String,
        default: ''
      },
    },
    filters: {
      richText(html) {
        var capture = html;
        if (html) {
       	  html = capture.replace(/src=\s*['"]([^'"]+)[^>]*>/gi, function(match, capture) {
            capture = ' src="' + capture +'" />';
            return capture;
          }).replace(/src=\s*['"]([^'"]+)[^>]*>/gi, function(match, capture) {
            capture = ' src="' + capture +'" />';
            return capture;
          })
        }
        return html;
      }
    },
  data() {
      var self = this
      return {
        reg: /<[^<>]+>/g,
        editorInit: {
          language: 'zh_CN',
          language_url: '/static/tinymce/langs/zh_CN.js',
          height: this.height,
          width: this.width,
          convert_urls: false,
          plugins: [
            'wordcount',
            'advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools importcss insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars'
          ],
          toolbar: [
            'wordcount searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample',
            'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen'
          ],
          // paste_webkit_styles: "all",
          // paste_merge_formats: false,
          paste_webkit_styles: "color min-height flex-flow section word-wrap hyphens -webkit-text-size-adjust font-size font-style font-family font-weight line-height padding padding-left padding-right padding-bottom padding-left list-style-type list-style-position list-style-image clip clear margin-top margin-right margin-bottom margin-left z-index left top right bottom float spacing white-space font box-sizing text-align text-transform text-decoration text-shadow display position flex-flow max-width background background-color background-image background-repeat background-position background-attachment background-clip background-size background-origin border border-style border-color border-width align-self box-shadow border-radius list-style overflow outline opacity visibility white-space border-color border-style transform transform-style align-items justify-content vertical-align flex width height margin border-top border-left border-right border-bottom border-top-color border-top-width border-top-style word-spacing font-stretch",
          branding: false,
          // extended_valid_elements: "svg[*],defs[*],pattern[*],desc[*],metadata[*],g[*],mask[*],path[*],line[*],marker[*],rect[*],circle[*],ellipse[*],polygon[*],polyline[*],linearGradient[*],radialGradient[*],stop[*],image[*],view[*],text[*],textPath[*],title[*],tspan[*],glyph[*],symbol[*],switch[*],use[*]",
          images_upload_handler: function(blobInfo, success, failure) {
            upload([blobInfo.blob()], self.scene_name).then((urls) => {
              success(urls[0])
            }).catch(() => {
              failure('上传失败，请重新上传')
            })
          }
        }
      }
    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
  /deep/ img {
    max-width: 100% !important;
  }
</style>
